import i18n from '../i18n/i18n'
import { JOB_STATUS, getStatusIndex } from '../constants/jobStatus'

// "Cleaning and onwards" generalizes to "In Progress and onwards" under the
// new generic status set — accepts either the old or new value via getStatusIndex.
export const isCleaningAndOnwards = (job) =>
    getStatusIndex(job.status) >= getStatusIndex(JOB_STATUS.IN_PROGRESS)

// "Cleaning completed and onwards" generalizes to "Finishing and onwards".
export const isCleaningCompletedAndOnwards = (job) =>
    getStatusIndex(job.status) >= getStatusIndex(JOB_STATUS.FINISHING)

// Client-side, user-friendly validation run before submitting a job.
// Returns a friendly message to show the user, or null when the job is valid.
export const validateJobForm = (job) => {
    if (!job.clientId)
        return i18n.t('orderForm.selectClientBeforeSaving')

    const lineItems = job.lineItemsTemp || []
    if (lineItems.some(item => item.type === 'MATERIAL' ? !item.materialId : !item.serviceId))
        return i18n.t('orderForm.lineItemNeedsServiceOrMaterial')

    return null
}